/**
 * Green Flag — UpcomingRegistration
 *
 * The /events top widget for the viewer's next registered event, wired up:
 * the clock that turns it over in the last hours, whether anyone is left to
 * Spark, and where its buttons go. UpcomingRegistrationWidget draws it.
 */

import type { UpcomingSparkForUser } from "@greenflagdate/shared";
import { useLocation, useNavigate } from "react-router-dom";
import { UpcomingRegistrationWidget } from "../UpcomingRegistrationWidget/UpcomingRegistrationWidget";
import { useIsEventSoon } from "../../lib/useIsEventSoon";
import { sparkMapEmbedUrl } from "../../lib/sparkMapEmbedUrl";
import { usePreSparkState } from "../../lib/usePreSparkState";

export function UpcomingRegistration({
  spark,
}: {
  spark: UpcomingSparkForUser;
}) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const soon = useIsEventSoon(spark.starts_at);
  // Asked again each time the viewer comes back to /events (the page stays
  // mounted under the deck), so finishing the deck turns the widget over
  // without a reload.
  const preSpark = usePreSparkState(spark.id, pathname === "/events");

  return (
    <UpcomingRegistrationWidget
      title={spark.title}
      startsAt={spark.starts_at}
      location={spark.location}
      img={spark.primary_image || spark.hero_image}
      mapEmbedUrl={sparkMapEmbedUrl(spark)}
      soon={soon}
      preSpark={preSpark}
      onOpenDetails={() =>
        navigate(`/event/atlanta/${spark.id}`, { state: { animate: true } })
      }
      onStartSparking={() => navigate(`/event/${spark.id}/spark`)}
    />
  );
}
